import { render, staticRenderFns } from "./WorkOrderCostHistory.vue?vue&type=template&id=2bdcc1a0&"
import script from "./WorkOrderCostHistory.vue?vue&type=script&lang=js&"
export * from "./WorkOrderCostHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports